import {Get_Bundlestatus} from '../constants/ActionTypes'

const INIT_STATE = {
    Statuslist: null,
    BundleMessage:'',
    Bundlestatus:''

};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case Get_Bundlestatus:
            return {
                Statuslist: action.body,
                BundleMessage:action.statusMessage,
                Bundlestatus:action.bundleStatus
              
            }
           

        default:
            return state;
    }
}